import { GaraMark, Sidebar } from '@/client/components/layout/sidebar';
import { TopBar } from '@/client/components/layout/topbar';
import { supabase } from '@/client/lib/supabase';
import { trpcVanilla } from '@/client/utils/trpc-client';
import { Outlet, createFileRoute, redirect, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/_app')({
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session) throw redirect({ to: '/login' });
  },
  loader: async () => {
    const { needsOnboarding } = await trpcVanilla.user.needsOnboarding.query();
    if (needsOnboarding) throw redirect({ to: '/onboarding' });
  },
  staleTime: Number.POSITIVE_INFINITY,
  pendingMs: 150,
  pendingComponent: AppSplash,
  component: AppLayout,
});

function AppLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <div className="flex h-[100dvh] overflow-hidden bg-background">
      <Sidebar />
      <div className="relative flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* Soft brand glow behind the top of every page */}
        <div
          aria-hidden
          className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-[radial-gradient(60%_100%_at_50%_0%,hsl(var(--primary)/0.07),transparent)]"
        />
        <TopBar />
        <main id="main-content" className="relative flex-1 overflow-y-auto">
          {/* grid + min-h-full lets pages that use h-full / -m-6 still fill the viewport */}
          <div
            key={pathname}
            className="animate-page-in grid min-h-full grid-cols-[minmax(0,1fr)] p-6"
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

/** Shown while the session and onboarding checks resolve on a hard load. */
function AppSplash() {
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-5 bg-background">
      <div className="animate-pulse">
        <GaraMark size={44} />
      </div>
      <div className="h-1 w-32 overflow-hidden rounded-full bg-muted">
        <div className="h-full w-1/3 animate-[splash-bar_1.1s_ease-in-out_infinite] rounded-full bg-brand-gradient" />
      </div>
    </div>
  );
}
